import styled from 'styled-components';

export const CollapseButtonWrapper = styled.div<{ isToggle: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${p => (p.isToggle ? 'flex-start' : 'center')};
  background: #f8f8f8;

  padding: 12px 24px;
  cursor: pointer;
  .text {
    color: ${props => props.theme.colors.text.primary};
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background: #f1f1f1;
  }
`;
